import { can } from "../../auth/can.ts";
import React from "react";
import Loader from "../Loader.tsx";
import { Partner } from "../../models/Partner.ts";
import InputEditProfile from "../formik/InputEditProfile.tsx";
import { useFormik } from "formik";
import { FillPreviewInfo } from "../../interfaces/formik/IEditUser.ts";
import { useSelector } from "react-redux";
import { RootState } from "../../store/index.ts";

import { useNavigate } from "react-router-dom";
import { notification } from "../../utils/Notifications.tsx";
import {
  getInfoPositionPartner,
  updateSalary,
  updateChiliInsurance,
  updateIsVacationsResponsible,
} from "../../services/partner.service.ts";
import CustomCheckboxField from "../formik/CustomCheckboxField.tsx";
import { getShifts } from "../../services/shift.service.ts";
import CustomSelectField from "../formik/CustomSelectField.tsx";
import SelectEditProfile from "../formik/SelectEditProfile.tsx";
import ModalContainer from "../ModalContainer.tsx";
import EditTimeAppoinment from "../config/EditTimeAppoinment.tsx";
import UpdateSalary from "./UpdateSalary.tsx";
import { Tooltip } from "@mui/material";
import {
  createFreeDay,
  fetchFreeDaysByDateRangeAndPartnerId,
} from "../../services/freeDay.service.ts";
import { weekDays, weeks } from "../../utils/constanst.js";
import { getPeriodicities } from "../../services/periodicty.service.ts";
import { getProfileTabPaneClass } from "./profileTabUtils.ts";

const InformationPosition = ({
  partner,
  reloadPage,
  isTabActive = false,
  embedded = false,
}: {
  partner: Partner;
  reloadPage: () => Promise<void>;
  isTabActive?: boolean;
  embedded?: boolean;
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [modalSalary, setModalSalary] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [selectedDays, setSelectedDays] = React.useState<number[]>([]);
  const [selectedWorkDays, setSelectedWorkDays] = React.useState<number[]>([]);
  const [periodicity, setPeriodicity] = React.useState<any[]>([]);
  const [showSalary, setShowSalary] = React.useState(false);

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: FillPreviewInfo(partner),
    onSubmit: async (values) => {
      const {
        monthlySalaryIMSS,
        monthlySalary,
        banDate,
        recruitmentDate,
        shiftManager,
        shift,
      } = values;
      console.log({ shiftManager });
      setLoading(true);
      try {
        const response = await updateSalary(partner.id, {
          salary: Number(monthlySalary),
          salaryIMSS: Number(monthlySalaryIMSS),
          banDate,
          recruitmentDate,
          shift,
          shiftManager,
          periodicityId: values.periodicity,
          diasTrabajo: selectedWorkDays.length > 0 ? selectedWorkDays.join(',') : '',
          ...(values.originalRecruitmentDateId != -1 && {
            recruitmentDateId: values.originalRecruitmentDateId,
            originalRecruitmentDate: values.originalRecruitmentDate,
          }),
        });

        if (typeof values.hasChiliLifeInsurance === "boolean") {
          await updateChiliInsurance(partner.id, {
            hasChiliLifeInsurance: values.hasChiliLifeInsurance,
          });
        }

        if (typeof values.isVacationsResponsible === "boolean") {
          await updateIsVacationsResponsible(partner.id, {
            isVacationsResponsible: values.isVacationsResponsible,
          });
        }

        notification("", "Datos actualizados", "success");

        await reloadPage();
        await fetchApplications();
      } catch (error) {
        notification(
          "Error",
          "Ocurrió un error al actualizar el salario",
          "danger"
        );
      } finally {
        setLoading(false);
      }
    },
  });
  const { user } = useSelector((state: RootState) => state.auth);

  const curp = partner.person.curp;
  const [shifts, setShifts] = React.useState<any[]>([]);

  const fetchApplications = async () => {
    if (!curp) return;
    try {
      const shiftsData = await getShifts();
      setShifts(shiftsData);

      const periodicitiesData = await getPeriodicities();
      setPeriodicity(
        Array.isArray(periodicitiesData) ? periodicitiesData : []
      );

      const freeDays = await fetchFreeDaysByDateRangeAndPartnerId(
        weeks[1]?.value,
        partner?.id
      );

      if (!weeks[1] || !partner?.id) {
        return;
      }

      formik.setFieldValue("week", weeks[1]?.id);

      if (freeDays?.days && Array.isArray(freeDays.days)) {
        const selectedDays = freeDays.days.map((day) => {
          const index = weekDays.findIndex((d) => d.name === day);

          if (index === -1) {
            throw new Error(`Día no válido: ${day}`);
          }

          return index;
        });

        setSelectedDays(selectedDays);
      } else {
        return;
      }
    } catch (error) {
      // ignore
    }
  };

  const [salary, setSalary] = React.useState<any>({});

  const fetchSalary = async () => {
    try {
      console.log("partner.id", partner.id);
      const responseSalary = await getInfoPositionPartner(partner.id);
      console.log("datos para usar en salario", responseSalary);
      setSalary(responseSalary);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    fetchApplications();
    fetchSalary();
    
    const diasTrabajo = (partner?.candidate as any)?.diasTrabajo;
    if (diasTrabajo) {
      const daysArray = diasTrabajo
        .split(',')
        .map((d: string) => parseInt(d.trim()))
        .filter((d: number) => !isNaN(d) && d >= 1 && d <= 7);
      setSelectedWorkDays(daysArray);
    } else {
      setSelectedWorkDays([]);
    }
  }, [curp, partner.id, (partner?.candidate as any)?.diasTrabajo]);

  const toggleWorkDay = (dayNumber: number) => {
    setSelectedWorkDays((prev) => {
      const newDays = prev.includes(dayNumber)
        ? prev.filter((d) => d !== dayNumber)
        : [...prev, dayNumber].sort((a, b) => a - b);
      formik.setFieldValue('diasTrabajo', newDays.join(','));
      return newDays;
    });
  };

  const getWorkDayName = (dayNumber: number) => {
    // Lunes=1, Martes=2, Miércoles=3, Jueves=4, Viernes=5, Sábado=6, Domingo=7
    const days = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
    return days[dayNumber - 1] || '';
  };

  const updateFreeDays = async () => {
    const { week } = formik.values;
    const days = selectedDays.map((day) => weekDays[day].id);
    try {
      const object = {
        partnerId: partner.id,
        days: weekDays
          .filter((day) => days.includes(day.id))
          .map((d) => d.name),
        dateRange: weeks.find((w) => w.id === week)?.value,
      };

      await createFreeDay(object);

      await fetchApplications();
      notification("Guardado", "Días libres actualizados", "success");
    } catch (error) {
      notification(
        "Error",
        "Ocurrió un error al actualizar los días libres",
        "danger"
      );
    } finally {
      setShowModal(false);
    }
  };

  const unclickable = !can("partners.edit", user) && !can("partners.edit_imss_salary", user);

  return (
    <div className={getProfileTabPaneClass(isTabActive, embedded)} id="empleo">
      <div className="table-responsive form-inline">
        <table className="table table-profile align-middle">
          <thead>
            <tr>
              <th />
              <th>
                <h4>
                  <small>Puesto: </small>
                  {partner.candidate.vacancy.position.name}
                </h4>
              </th>
            </tr>
          </thead>
          <tbody className="overflow-x-hidden">
            <tr className="highlight">
              <td colSpan={2} />
            </tr>
            <InputEditProfile
              formik={formik}
              field="originalRecruitmentDate"
              label="Fecha de reclutamiento"
              placeholder="Fecha de reclutamiento"
              sm={3}
              type="date"
              unclickable={unclickable}
            />
            <InputEditProfile
              formik={formik}
              field="recruitmentDate"
              label="Fecha de cambio de posición"
              placeholder="Fecha de cambio de posición"
              sm={3}
              type="date"
              unclickable={unclickable}
            />

            {can("partners.view_salary", user) && (
              <InputEditProfile
                formik={formik}
                field="monthlySalaryString"
                label="Salario"
                placeholder="Salario"
                sm={3}
                disabled
                displayValue={
                  showSalary
                    ? formik.values.monthlySalaryString
                    : "*".repeat(
                        Math.max(
                          6,
                          String(formik.values.monthlySalaryString || "").length
                        )
                      )
                }
                button={
                  <div className="d-flex align-items-center gap-2 ms-2">
                    <Tooltip
                      title={showSalary ? "Ocultar salario" : "Mostrar salario"}
                      arrow
                    >
                      <button
                        type="button"
                        className="btn btn-link p-0 border-0 shadow-none profile-salary-toggle-eye"
                        onClick={() => setShowSalary((prev) => !prev)}
                        aria-label={
                          showSalary ? "Ocultar salario" : "Mostrar salario"
                        }
                        style={{
                          color: "#000000",
                          background: "transparent",
                          lineHeight: 1,
                          minWidth: "auto",
                        }}
                      >
                        <i
                          className={`fa-solid ${
                            showSalary ? "fa-eye-slash" : "fa-eye"
                          }`}
                          style={{ color: "#000000", fontSize: "1.1rem" }}
                        />
                      </button>
                    </Tooltip>
                    <Tooltip title="Modificar salario" arrow>
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => setModalSalary(true)}
                      >
                        <i className="fa-solid fa-pen-to-square" />
                      </button>
                    </Tooltip>
                  </div>
                }
              />
            )}

            {can("partners.view_imss_salary", user) && (
              <InputEditProfile
                formik={formik}
                field="monthlySalaryIMSS"
                label="Salario IMSS"
                placeholder="Salario IMSS"
                sm={3}
                type="number"
              />
            )}
            <tr>
              <td className="field">Turno: </td>
              <td>
                <SelectEditProfile
                  list={shifts}
                  formik={formik}
                  field="shift"
                  label="Turno"
                  key={shifts.length}
                  sm={3}
                  disabled={unclickable}
                />
              </td>
            </tr>
            <tr>
              <td className="field">Periodicidad: </td>
              <td>
                <SelectEditProfile
                  list={periodicity}
                  formik={formik}
                  field="periodicity"
                  label="Periodicidad"
                  key={periodicity.length}
                  sm={3}
                  disabled={unclickable}
                />
              </td>
            </tr>

            <InputEditProfile
              formik={formik}
              field="branchName"
              label="Sucursal"
              placeholder="Sucursal"
              sm={3}
              unclickable={true}
            />
            <InputEditProfile
              formik={formik}
              field="comments"
              label="Comentarios"
              placeholder="Comentarios"
              sm={3}
              unclickable={true}
            />
            <tr>
              <td className="field">Días que va a trabajar: </td>
              <td>
                <div className="col-md-12">
                  <div className="d-flex flex-wrap gap-2">
                    {[1, 2, 3, 4, 5, 6, 7].map((dayNumber) => (
                      <button
                        key={dayNumber}
                        type="button"
                        className={`btn ${selectedWorkDays.includes(dayNumber) ? 'btn-primary' : 'btn-outline-secondary'}`}
                        onClick={() => toggleWorkDay(dayNumber)}
                        disabled={unclickable}
                        style={{ 
                          width: '45px',
                          height: '45px',
                          borderRadius: '50%',
                          padding: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '11px',
                          fontWeight: '500'
                        }}
                        title={getWorkDayName(dayNumber)}
                      >
                        {getWorkDayName(dayNumber).substring(0, 3)}
                      </button>
                    ))}
                  </div>
                </div>
              </td>
            </tr>
            <tr className="w-100" style={{ overflow: "hidden" }}>
              <td colSpan={2} className="ps-5">
                <CustomCheckboxField
                  formik={formik}
                  classInput="ps-4 ms-5 w-75"
                  field="shiftManager"
                  label="Jefe de turno"
                  mdLabel={2}
                  disable={unclickable}
                />
              </td>
            </tr>

            <tr className="w-100" style={{ overflow: "hidden" }}>
              <td colSpan={2} className="ps-5">
                <CustomCheckboxField
                  formik={formik}
                  classInput="ps-4 ms-5 w-75"
                  field="hasChiliLifeInsurance"
                  label="Seguro Chili"
                  mdLabel={2}
                  disable={unclickable}
                />
              </td>
            </tr>

            <tr className="w-100" style={{ overflow: "hidden" }}>
              <td colSpan={2} className="ps-5">
                <CustomCheckboxField
                  formik={formik}
                  classInput="ps-4 ms-5 w-75"
                  field="isVacationsResponsible"
                  label="Responsable de vacaciones"
                  mdLabel={2}
                  disable={unclickable}
                />
              </td>
            </tr>

            {partner.partnerStatus.name === "Baja" && (
              <InputEditProfile
                formik={formik}
                field="banDate"
                label="Fecha de baja"
                placeholder="Fecha de baja"
                sm={3}
                type="date"
              />
            )}

            {/* <tr className="w-100" style={{ overflow: "hidden" }}>
              <td colSpan={3} className="ps-5">
                <div
                  className={`row mb-15px fs-13px d-flex align-items-center`}
                >
                  <label
                    className={`form-label col-form-label col-md-2 text-end me-2`}
                  >
                    Días libres:
                  </label>
                  <div className="col-md-3">
                    <button
                      className="btn btn-primary"
                      onClick={() => setShowModal(true)}
                    >
                      Editar
                    </button>
                  </div>
                </div>
              </td>
            </tr> */}

            {!unclickable && (
              <tr className="highlight">
                <td className="field">&nbsp;</td>
                <td className="">
                  <button
                    type="submit"
                    className="btn btn-secondary w-150px ms-5px"
                    style={{ marginRight: "4%" }}
                    onClick={() => navigate("/colaboradores")}
                  >
                    Regresar
                  </button>
                  <button
                    type="submit"
                    className="btn btn-azul w-150px"
                    style={{ marginRight: "4%" }}
                    onClick={() => formik.handleSubmit()}
                    disabled={!formik.dirty}
                  >
                    Actualizar datos
                  </button>
                </td>
              </tr>
            )}

            {/* Movimientos (reintegraciones, cambios de posición/sucursal/salario) se muestran en la pestaña "Movimientos" */}
          </tbody>
        </table>
      </div>
      <ModalContainer
        title="Modificar salario"
        open={modalSalary}
        closeFn={() => setModalSalary(false)}
        children={
          <UpdateSalary
            closeFn={() => setModalSalary(false)}
            refreshFn={async () => {
              await reloadPage();
              await fetchApplications();
            }}
            setLoading={(value) => setLoading(value)}
            dataSalary={salary}
          />
        }
      />
      <Loader isLoading={loading} />
      <ModalContainer
        open={showModal}
        title="Días libres del colaborador"
        closeFn={() => setShowModal(false)}
      >
        <div className="form-group">
          <CustomSelectField
            formik={formik}
            field="week"
            label="Semana"
            list={weeks}
            sm={6}
          />
        </div>
        <div className="d-flex w-100 my-3 col-md-12">
          <label className={`form-label col-form-label col-md-3 text-end pe-4`}>
            Día(s)*
          </label>
          <div className="col-9 d-flex flex-row">
            {weekDays.map((day, index) => (
              <button
                key={index}
                type="button"
                onClick={() => {
                  const isSelected = selectedDays.includes(index);
                  setSelectedDays(
                    isSelected
                      ? selectedDays.filter((dayIndex) => dayIndex !== index)
                      : [...selectedDays, index]
                  );
                }}
                className={`btn ${
                  selectedDays.includes(index)
                    ? "btn-primary"
                    : "btn-outline-secondary"
                } rounded-pill mx-1`}
                title={day.name}
                style={{
                  width: "30px",
                  height: "30px",
                  textTransform: "capitalize",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {day.name.slice(0, 1)}
              </button>
            ))}
          </div>
        </div>
        <div className="d-flex flex-row mt-5">
          <button
            className="btn btn-secondary ms-auto me-2"
            onClick={() => setShowModal(false)}
          >
            Cancelar
          </button>
          <button className="btn btn-primary" onClick={updateFreeDays}>
            Guardar
          </button>
        </div>
      </ModalContainer>
    </div>
  );
};

export default InformationPosition;
